import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["label", "meta"];
import PropTypes from 'prop-types';
import React, { cloneElement, forwardRef } from 'react';
import { TAG_SIZES } from '../../constants';
import { ProgressStepperStepLabelText } from '../ProgressStepperStepLabelText/ProgressStepperStepLabelText';
import { Text } from '../Text/Text';
import { StyledProgressStepperStepLabel } from './ProgressStepperStepLabel.styles';

/**
 * Used by `ProgressStepperStep` to wrap a step's label text and any additional `meta` content.
 *
 * @since 8.57.0
 */
export var ProgressStepperStepLabel = /*#__PURE__*/forwardRef(function (_ref, forwardedRef) {
  var _meta$type;
  var label = _ref.label,
    meta = _ref.meta,
    rest = _objectWithoutProperties(_ref, _excluded);
  var metaContent = meta;
  if (typeof meta === 'string') {
    metaContent = /*#__PURE__*/React.createElement(Text, {
      fontType: "bodySmall"
    }, meta);
  } else if ((meta === null || meta === void 0 ? void 0 : (_meta$type = meta.type) === null || _meta$type === void 0 ? void 0 : _meta$type.displayName) === 'Tag') {
    // Force Tag to display at small size
    metaContent = /*#__PURE__*/cloneElement(meta, {
      size: TAG_SIZES.sm
    });
  }
  return /*#__PURE__*/React.createElement(StyledProgressStepperStepLabel, _extends({
    ref: forwardedRef
  }, rest), /*#__PURE__*/React.createElement(ProgressStepperStepLabelText, null, label), metaContent);
});
ProgressStepperStepLabel.displayName = 'ProgressStepperStepLabel';
ProgressStepperStepLabel.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Label text of the step.
   */
  label: PropTypes.string.isRequired,
  /**
   * Additional content that will appear underneath the step label text. Currently,
   * `Tag` and text are officially supported. For more
   * customization options, you can use the `renderLabel` prop.
   *
   * It's best to avoid long `meta` values to help maintain understandability
   * for screen reader users.
   *
   * @since 8.57.0
   */
  meta: PropTypes.oneOfType([PropTypes.string, PropTypes.node])
} : {};